import React from 'react'
import usePageMeta from '../hooks/usePageMeta'
import Navbar from '../components/navbar/Navbar'
import AboutHeader from '../components/header_about/AboutHeader'
import About from '../components/about/About'
import Footer from '../components/footer/Footer'

export default function AboutPage() {
  usePageMeta({
    title: 'About Our Preschool | Learning In Motion Preschool, Cooper City FL',
    description: 'Meet the team behind Learning In Motion Preschool, a Gold Seal accredited preschool serving Cooper City, FL families.',
    path: '/about',
  })

  return (
    <>
      <Navbar/>
      <AboutHeader/>
      <About/>
      <Footer/>
    </>
  )
}
